<ion-list class="language-list" lines="none"  [ngClass]="{'ion-hide-lg-down': !showListStyle}"  >
    <ion-item (click)="presentPopover($event)">
        <div class="language">
            <img src="{{ selectedLanguageIcon }}" alt="" class="language-icon">
            {{ getLanguageText(activeLanguage) }}
            <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.32293 6.88394C3.5251 6.64807 3.88021 6.62075 4.11608 6.82293L9.00001 11.0092L13.8839 6.82293C14.1198 6.62075 14.4749 6.64807 14.6771 6.88394C14.8793 7.11981 14.8519 7.47492 14.6161 7.67709L9.36608 12.1771C9.15543 12.3576 8.84459 12.3576 8.63394 12.1771L3.38394 7.67709C3.14807 7.47492 3.12075 7.11981 3.32293 6.88394Z" fill="#3F403F"/>
            </svg>

        </div>
    </ion-item>
    <ion-popover #popover [isOpen]="isPopoverLangOpen" (didDismiss)="isPopoverLangOpen = false"
                 alignment="center" side="bottom"  size="auto" class="language-popover" mode="ios">
        <ng-template>
            <ion-content class="languages-wrapper">
                <ion-list [inset]="true" *ngIf="availableLanguages" lines="none">
                    <ion-item *ngFor="let lang of availableLanguages" (click)="changeLang(lang)" class="item">
                        {{ getLanguageText(lang) }}
                    </ion-item>
                </ion-list>
            </ion-content>
        </ng-template>
    </ion-popover>
</ion-list>

<div class="btn-wrapper  languages ion-text-center ion-hide-lg-up" [ngClass]="{'ion-hide': showListStyle}">
    <button  type="button" class="btn-primary btn-lang"
             *ngFor="let lang of availableLanguages"
             [ngClass]="{ 'active-lang': activeLanguage === lang }"
             (click)="changeLang(lang)">

        <img [src]="getLanguageImage(lang)"  height="19px" [alt]="lang">
        {{getLanguageText(lang) }}

    </button>
</div>
